import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ArrowLeft, Mail, Loader2, CheckCircle } from 'lucide-react';
import Logo from '../components/Logo';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { setError('Email required'); return; }
    setLoading(true); setError('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Something went wrong');
    } finally { setLoading(false); }
  };

  const inputStyle = { background: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.12)', color: 'white' };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0A0F1E' }}>
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8"><Logo size={36} showText light /></div>
        {sent ? (
          <div className="text-center">
            <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5"
              style={{ background: 'rgba(22,163,74,0.15)', border: '1px solid rgba(22,163,74,0.3)' }}>
              <CheckCircle size={32} className="text-green-500" />
            </div>
            <h2 className="font-heading text-2xl font-bold text-white mb-2">Check your email</h2>
            <p className="text-sm mb-6" style={{ color: 'rgba(148,163,184,0.7)' }}>If <strong className="text-white">{email}</strong> has an account, we sent a reset link. Check your inbox and spam folder.</p>
            <Link to="/login"><Button className="w-full h-11">Back to Sign In</Button></Link>
          </div>
        ) : (
          <>
            <Link to="/login" className="flex items-center gap-1.5 text-xs mb-7 hover:text-white transition-colors" style={{ color: 'rgba(100,116,139,0.6)' }}>
              <ArrowLeft size={13} /> Back to Sign In
            </Link>
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
              style={{ background: 'rgba(37,99,235,0.15)', border: '1px solid rgba(37,99,235,0.3)' }}>
              <Mail size={22} className="text-blue-400" />
            </div>
            <h2 className="font-heading text-2xl font-bold text-white mb-1">Forgot password?</h2>
            <p className="text-sm mb-7" style={{ color: 'rgba(148,163,184,0.7)' }}>Enter your email and we’ll send a reset link.</p>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold uppercase tracking-wide text-slate-400">Email address</Label>
                <Input value={email} onChange={e => setEmail(e.target.value)} placeholder="you@practice.com" type="email" style={inputStyle} className="h-11" autoFocus />
                {error && <p className="text-xs text-red-400">{error}</p>}
              </div>
              <Button type="submit" className="w-full h-11 gap-2 font-semibold" disabled={loading}>
                {loading ? <><Loader2 size={15} className="animate-spin" /> Sending…</> : <><Mail size={15} /> Send Reset Link</>}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
